// extracted by mini-css-extract-plugin
export var locationCard = "_if-0";